<template>
  <el-dialog
  :visible="inventoryDialogVisible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span v-if="!isEditionMode()" class="title" >Créer un inventaire</span>
    <span v-if="isEditionMode()" class="title" >Modifier un inventaire</span>
  </span>
  <el-row>
    <el-col :span="6" :offset="6" :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
      <el-form label-position="top" label-width="100px" :model="inventory" :rules="rules" ref="inventoryForm">
        <el-form-item label="Nom" prop="name">
          <el-input v-model="inventory.name"></el-input>
        </el-form-item>
        <el-form-item label="Description">
          <el-input v-model="inventory.description"></el-input>
        </el-form-item>
        <el-divider/>
        <h3>Options</h3>
        <el-row>
          <el-col>
            <p>La gestion des délais permet de spécifier une date à laquelle les produits doivent être vendus.</p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item label=" ">
               <el-checkbox v-model="inventory.delay_management" :disabled="!canConfigure">Gérer les délais</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item label="1er délai (jours)">
              <el-input-number v-model="inventory.product_delay" :disabled="!inventory.delay_management" size="small" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item label="Limite (jours)">
              <el-input-number v-model="inventory.product_delay_limit" :disabled="!inventory.delay_management" size="small" :min="inventory.product_delay"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item label=" ">
               <el-checkbox v-model="inventory.default" :disabled="!canConfigure">Inventaire par défaut (commande)</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item label=" ">
               <el-checkbox v-model="inventory.ind_reservation" :disabled="!canConfigure">Activer la gestion des réservations</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label=" ">
               <el-checkbox v-model="inventory.ind_agency" :disabled="!canConfigure">Activer la gestion de frais d'agence</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="Produit de frais d'agence" prop="agencyFeeProduct">
              <SelectProduct 
                :type="0"
                :active="true"
                :product="inventory.agencyFeeProduct"
                :disabled="!inventory.ind_agency"
                @selected="handleSelectProduct"
              />
              <!-- <el-select v-model="inventory.agency_fee_product" placeholder="Select" >
                <el-option
                  v-for="p in listServiceProduct"
                  :key="p.id"
                  :label="p.name"
                  :value="p.id">
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider/>
      </el-form>
    </el-col>
  </el-row>
  <!-- <el-row v-if="getAddress!=null">
    <el-col  :offset="6" :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="margin-top:10px;padding:30px;">
       <AddressCard :address="getAddress" :index="0" @remove="removeAddress" @edit="editAddress"></AddressCard>
    </el-col>
  </el-row>
  <el-row v-if="getAddress==null">
    <el-col :offset="6" :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="margin-top:10px;padding:30px;">
        <div @click="addNewAddress" style="height:175px;display:table;width:100%;">
          <el-card class="dotted-card" :shadow="'never'" style="height:175px;text-align: center;display:table-cell;vertical-align: middle;">
            Spécifier le lieu physique de l'inventaire
          </el-card>
        </div>
        <AddressForm :addressFormVisible.sync="addressFormVisible" :modal="false" @add="addAddress" @change="replaceAddress" :addressToEdit="addressToEdit" @close="closeAddressForm"></AddressForm>
    </el-col>
  </el-row> -->
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeNewInventoryDialog">Annuler</el-button>
    <el-button v-if="!isEditionMode()" type="primary" @click="addInventory">Créer</el-button>
    <el-button v-if="isEditionMode()" type="primary" @click="editInventory">Modifier</el-button>
  </span>
</el-dialog>
</template>
<script>
import axios from "axios"

import SelectProduct from '@/components/product/select-product.vue'
import AddressEditor from '@/components/address/Address-Editor'
import AddressCard from '@/components/address/Address-Card'

import InventoryAPI from '@/services/API/inventory'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'InventoryDialog',
	props: {
		inventoryDialogVisible : Boolean,
    inventoryToEdit : Object,
	},
  data() {
    var validateAgencyFeeProduct = (rule, value, callback) => {
        if(this.inventory.ind_agency === true && (value ==null || value == '')){
          callback(new Error("Veuillez spécifier un produit de frais d'agence"));
        }else{
          callback();
        }
      };
    return {
      inventory : {
        addresses : null,
        name : null,
        description : null,
        delay_management : null,
        product_delay : null,
        product_delay_limit : null,
        ind_reservation : null,
        ind_agency : null,
        agency_fee_product:null
      },
      rules : {
  	  	name : [
  	  		 	{ required: true, message: 'Veuillez saisir un nom.', trigger: 'blur' }
  	  		],
        agencyFeeProduct: [
          { validator : validateAgencyFeeProduct, trigger: 'blur' }
        ]
  	  },
      addressFormVisible : false,
      addressToEdit : null,
      fullScreenLoading : false,
    };
  },components: {
    AddressEditor,
    AddressCard,
    SelectProduct,
  },
	methods: {
    handleSelectProduct(productSelected){
      if (productSelected === '') {
        this.inventory.agencyFeeProduct = null;;
      } else {
        this.inventory.agencyFeeProduct = productSelected;
      }
      
    },
    isEditionMode(){
      return this.inventoryToEdit!=null;
    },
    open(){
      this.fetchProducts();
      if(this.isEditionMode()){
        this.inventory = _.cloneDeep(this.inventoryToEdit);
      }
    },

    closeNewInventoryDialog(){
      this.$refs.inventoryForm.resetFields();
      this.inventory = {};
      this.inventory.addresses=null;
      this.$emit('close');
    },
    addInventory(){
      this.$refs['inventoryForm'].validate((valid)=>{
        if(valid){
          this.fullScreenLoading = true;
          this.inventory.agency_fee_product = _.get(this.inventory, 'agencyFeeProduct.id');
          this.createInventory(this.inventory)
            .then(valid=>{
              if(valid){
                this.fullScreenLoading = false;
                this.$emit('inventoryCreated', this.inventory);
                this.invalidateInventories();
              }
            })
        }
      });
    },
    editInventory(){
      this.$refs['inventoryForm'].validate((valid)=>{
        if(valid){
          this.invalidateStockItems();
          this.fullScreenLoading = true;
          this.inventory.agency_fee_product = _.get(this.inventory, 'agencyFeeProduct.id');
          this.updateInventory(this.inventory)
            .then((valid)=>{
              if(valid){
                this.fullScreenLoading = false;
                this.$emit('inventoryUpdated');
                this.invalidateInventories();
              }
            })
          }
        });
    },
    addNewAddress(){
      this.addressToEdit=null;
      this.addressFormVisible=true;
    },
    addAddress(address){
      this.inventory.addresses = [];
      this.inventory.addresses.push(address);
      this.closeAddressForm();
    },
    replaceAddress(address){
      this.inventory.addresses = [];
      this.inventory.addresses.push(address);
      this.closeAddressForm();
    },
    closeAddressForm(){
      this.addressFormVisible=false;
    },
    removeAddress(){
      this.inventory.addresses = null;
    },
    editAddress(){
      this.addressFormVisible=true;
    },
    ...mapActions('stockItems',['invalidateStockItems']),
    ...mapActions('inventory',['updateInventory','createInventory']),
    ...mapActions('products', ['fetchProducts']),
    ...mapActions('controlData', ['invalidateInventories'])
	},
	computed: {
    canConfigure () {
      return _.get(this.inventory, 'code') !== 'SAQ';
    },
    getAddress(){
      if(this.inventory.addresses!=null && this.inventory.addresses.length>0){
        return this.inventory.addresses[0];
      }
      return null;
    },
    ...mapGetters('products',['listServiceProduct']),
	}
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.title {
	font-size : 1.8em;
	font-weight:bold;

}

.dotted-card{
	border: 2px dashed #D1CFCF;
	background-color: rgba(216,216,216,0.1);
	font-family: Helvetica-Bold;
	font-size: 14px;
	letter-spacing: 0.32px;
	text-align: center;
	color:#9AA2AC;
	margin-bottom:20px;
}

.el-card__body, .el-card{
	position:relative;
}

.dotted-card:hover{
	cursor:pointer;
	color: #4A596A;
}

@media (max-width: 1024px) {


}
</style>
